import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import classNames from 'classnames';
import styles from './CoverageDocs.module.css';

import { ReactComponent as MapImage } from '../../../assets/images/Vendor/Apple/map.svg';
import useTranslation from '../../../components/contexts/LanguageTranslation/useTranslation';
import { CircleFlag } from 'react-circle-flags';

const GermanyFlag = () => (
    <CircleFlag
        countryCode='de'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const SpainFlag = () => (
    <CircleFlag
        countryCode='es'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const ItalyFlag = () => (
    <CircleFlag
        countryCode='it'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const FranceFlag = () => (
    <CircleFlag
        countryCode='fr'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const AustriaFlag = () => (
    <CircleFlag
        countryCode='at'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const UKFlag = () => (
    <CircleFlag
        countryCode='gb'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const AustraliaFlag = () => (
    <CircleFlag
        countryCode='au'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const DenmarkFlag = () => (
    <CircleFlag
        countryCode='dk'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const FinlandFlag = () => (
    <CircleFlag
        countryCode='fi'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const IrelandFlag = () => (
    <CircleFlag
        countryCode='ie'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const NetherlandsFlag = () => (
    <CircleFlag
        countryCode='nl'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const NorwayFlag = () => (
    <CircleFlag
        countryCode='no'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const NewzealandFlag = () => (
    <CircleFlag
        countryCode='nz'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const SwitzerlandFlag = () => (
    <CircleFlag
        countryCode='ch'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const SwedenFlag = () => (
    <CircleFlag
        countryCode='se'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const USFlag = () => (
    <CircleFlag
        countryCode='us'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const ChileFlag = () => (
    <CircleFlag
        countryCode='cl'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const JapanFlag = () => (
    <CircleFlag
        countryCode='jp'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const IndiaFlag = () => (
    <CircleFlag
        countryCode='in'
        height='24'
        style={{ marginRight: '16px' }}
    />
);
const MexicoFlag = () => (
    <CircleFlag
        countryCode='mx'
        height='24'
        style={{ marginRight: '16px' }}
    />
);

const getSwissLink = (lang) => {
    switch (lang) {
        case 'fr':
            return 'https://apple.com/chfr/legal/sales-support/';
        case 'sg':
        case 'it':
        case 'en':
            return 'https://apple.com/chde/legal/sales-support/';
        default:
            return 'https://apple.com/chde/legal/sales-support/';
    }
};

const RegionHeader = ({ heading }) => {
    return (
        <div className={styles.regionHeader}>
            <h4 className={classNames(styles.headingLabel, 'mb-6')}>{heading}</h4>
            <hr className={styles.seperator} />
        </div>
    );
};

const CountryContainer = ({ icon, label, link = '', ariaLabel, countryHandler = () => {} }) => {
    return (
        <div className={styles.countryItem}>
            <a
                href={link}
                onClick={countryHandler}
                ariaLabel={ariaLabel}
                target='_blank'
                className={styles.countryLabel}
            >
                <div className={styles.flagIcon}>{icon}</div>
                <div className={styles.flagLabel}>{label}</div>
            </a>
        </div>
    );
};

const InternationalCoverageDocs = ({ language }) => {
    const international = useTranslation('screens/Vendor/Apple/InternationalCoverageDocs');
    const { translations, isTranslationResolved } = international;

    if (!isTranslationResolved) return null;

    return (
        <div className={styles.pageContainer}>
            <div className={styles.pageHeaderCoverDetails}>
                <Container className={styles.pageHeaderContentCoverDetails}>
                    <h1 className='mb-lg-3 mb-md-3 mb-sm-3 mb-1'>
                        {translations.title || 'Want to View Your Coverage Details?'}
                    </h1>
                    <p>{translations.subtitle || 'Select the country where you purchased your plan.'}</p>
                    {/* <p class="mb-0">Or <a href="https://www.apple.com/legal/sales-support/applecare/applecareplus/us/" target="blank">click here</a> to view the AppleCare+ portion of your AppleCare+ with Theft and Loss terms and conditions.</p> */}
                </Container>
            </div>
            <Container>
                <Row>
                    <Col className={styles.pageBodyContent}>
                        <div className={styles.mapContainer}>
                            <MapImage />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className={styles.countryHeading}>
                        <h2 className={classNames('h4', styles.headingLabelMain)}>
                            {translations.selectCountry || 'Choose Your Country'}
                        </h2>
                    </Col>
                </Row>

                <Row>
                    <Col
                        xs='12'
                        lg='9'
                        className='mx-auto'
                    >
                        <RegionHeader heading={translations.africaMiddleEastIndia || 'Africa, Middle East and India'} />
                        <div className={styles.regionContainer}>
                            <CountryContainer
                                icon={IndiaFlag()}
                                label={translations.india || 'India'}
                                ariaLabel={
                                    translations.indiaAria
                                    || 'Click to open the India coverage documents in a new window.'
                                }
                                link={'https://apple.com/in/legal/sales-support/'}
                            />
                        </div>
                    </Col>
                </Row>
                <br className='show-md-up' />
                <Row>
                    <Col
                        lg='9'
                        className='mx-auto'
                    >
                        <RegionHeader heading={translations.asiaPacific || 'Asia Pacific'} />
                        <div className={styles.regionContainer}>
                            <CountryContainer
                                icon={AustraliaFlag()}
                                label={translations.australia || 'Australia'}
                                ariaLabel={
                                    translations.australiaAria
                                    || 'Click to open the Australia coverage documents in a new window.'
                                }
                                link={'https://apple.com/au/legal/sales-support/'}
                            />
                            <CountryContainer
                                icon={JapanFlag()}
                                label={translations.japan || 'Japan'}
                                ariaLabel={
                                    translations.japanAria
                                    || 'Click to open the Japan coverage documents in a new window.'
                                }
                                link={'https://apple.com/jp/legal/sales-support/'}
                            />
                            <CountryContainer
                                icon={NewzealandFlag()}
                                label={translations.newZealand || 'New Zealand'}
                                ariaLabel={
                                    translations.newZealandAria
                                    || 'Click to open the New Zealand coverage documents in a new window.'
                                }
                                link={'https://apple.com/nz/legal/sales-support/'}
                            />
                            {/* left for future implementation */}
                            {/*<CountryContainer*/}
                            {/*    icon={VietnamFlag()}*/}
                            {/*    label={translations.vietnam || "Vietnam"}*/}
                            {/*    ariaLabel={translations.vietnamFlag || "Click to open the United States AppleCare+ with Theft and Loss coverage documents in a new window."}*/}
                            {/*// countryHandler={onSelectUsMap}  // Displaying the vietnam flag as per the Design screen*/}
                            {/*/>*/}
                        </div>
                    </Col>
                </Row>
                <br className='show-md-up' />

                <Row>
                    <Col
                        xs='12'
                        lg='9'
                        className='mx-auto'
                    >
                        <RegionHeader heading={translations.europe || 'Europe'} />
                        <div className={styles.regionContainer}>
                            <CountryContainer
                                icon={AustriaFlag()}
                                label={translations.austria || 'Austria'}
                                ariaLabel={
                                    translations.austriaAria
                                    || 'Click to open the Austria coverage documents in a new window.'
                                }
                                link={'https://apple.com/at/legal/sales-support/'}
                            />
                            <CountryContainer
                                icon={DenmarkFlag()}
                                label={translations.denmark || 'Denmark'}
                                ariaLabel={
                                    translations.denmarkAria
                                    || 'Click to open the Denmark coverage documents in a new window.'
                                }
                                link={'https://apple.com/dk/legal/sales-support/'}
                            />
                            <CountryContainer
                                icon={FinlandFlag()}
                                label={translations.finland || 'Finland'}
                                ariaLabel={
                                    translations.finlandAria
                                    || 'Click to open the Finland coverage documents in a new window.'
                                }
                                link={'https://apple.com/fi/legal/sales-support/'}
                            />
                            <CountryContainer
                                icon={FranceFlag()}
                                label={translations.france || 'France'}
                                ariaLabel={
                                    translations.franceAria
                                    || 'Click to open the France coverage documents in a new window.'
                                }
                                link={'https://apple.com/fr/legal/sales-support/'}
                            />
                            <CountryContainer
                                icon={GermanyFlag()}
                                label={translations.germany || 'Germany'}
                                ariaLabel={
                                    translations.germanyAria
                                    || 'Click to open the Germany coverage documents in a new window.'
                                }
                                link={'https://apple.com/de/legal/sales-support/'}
                            />
                            <CountryContainer
                                icon={IrelandFlag()}
                                label={translations.ireland || 'Ireland'}
                                ariaLabel={
                                    translations.irelandAria
                                    || 'Click to open the Ireland coverage documents in a new window.'
                                }
                                link={'https://apple.com/ie/legal/sales-support/'}
                            />
                            <CountryContainer
                                icon={ItalyFlag()}
                                label={translations.italy || 'Italy'}
                                ariaLabel={
                                    translations.italyAria
                                    || 'Click to open the Italy coverage documents in a new window.'
                                }
                                link={'https://apple.com/it/legal/sales-support/'}
                            />
                            <CountryContainer
                                icon={NetherlandsFlag()}
                                label={translations.netherlands || 'Netherlands'}
                                ariaLabel={
                                    translations.netherlandsAria
                                    || 'Click to open the Netherlands coverage documents in a new window.'
                                }
                                link={'https://apple.com/nl/legal/sales-support/'}
                            />
                            <CountryContainer
                                icon={NorwayFlag()}
                                label={translations.norway || 'Norway'}
                                ariaLabel={
                                    translations.norwayAria
                                    || 'Click to open the Norway coverage documents in a new window.'
                                }
                                link={'https://apple.com/no/legal/sales-support/'}
                            />
                            <CountryContainer
                                icon={SpainFlag()}
                                label={translations.spain || 'Spain'}
                                ariaLabel={
                                    translations.spainAria
                                    || 'Click to open the Spain coverage documents in a new window.'
                                }
                                link={'https://apple.com/es/legal/sales-support/'}
                            />
                            <CountryContainer
                                icon={SwedenFlag()}
                                label={translations.sweden || 'Sweden'}
                                ariaLabel={
                                    translations.swedenAria
                                    || 'Click to open the Sweden coverage documents in a new window.'
                                }
                                link={'https://apple.com/se/legal/sales-support/'}
                            />
                            <CountryContainer
                                icon={SwitzerlandFlag()}
                                label={translations.switzerland || 'Switzerland'}
                                ariaLabel={
                                    translations.switzerlandAria
                                    || 'Click to open the Switzerland coverage documents in a new window.'
                                }
                                link={getSwissLink(language)}
                            />
                            <CountryContainer
                                icon={UKFlag()}
                                label={translations.unitedKingdom || 'United Kingdom'}
                                ariaLabel={
                                    translations.unitedKingdomAria
                                    || 'Click to open the United Kingdom coverage documents in a new window.'
                                }
                                link={'https://apple.com/uk/legal/sales-support/'}
                            />
                        </div>
                    </Col>
                </Row>
                <br className='show-md-up' />

                <Row>
                    <Col
                        lg='9'
                        className='mx-auto'
                    >
                        <RegionHeader
                            heading={translations.latinAmericaCarribean || 'Latin America and the Caribbean'}
                        />
                        <div className={styles.regionContainer}>
                            <CountryContainer
                                icon={ChileFlag()}
                                label={translations.chile || 'Chile'}
                                ariaLabel={
                                    translations.chileAria
                                    || 'Click to open the Chile coverage documents in a new window.'
                                }
                                link={'https://apple.com/cl/legal/sales-support/'}
                            />
                            <CountryContainer
                                icon={MexicoFlag()}
                                label={translations.mexico || 'Mexico'}
                                ariaLabel={
                                    translations.mexicoAria
                                    || 'Click to open the Mexico coverage documents in a new window.'
                                }
                                link={'https://apple.com/mx/legal/sales-support/'}
                            />
                        </div>
                    </Col>
                </Row>
                <br className='show-md-up' />
                <Row>
                    <Col
                        lg='9'
                        className='mx-auto'
                    >
                        <RegionHeader
                            heading={
                                translations.unitedStatesCanadaPuertoRico || 'The United States, Canada and Puerto Rico'
                            }
                        />
                        <div className={styles.regionContainer}>
                            <CountryContainer
                                icon={USFlag()}
                                label={translations.unitedStates || 'United States'}
                                ariaLabel={
                                    translations.unitedStatesAria
                                    || 'Click to open the United States coverage documents in a new window.'
                                }
                                link={'https://apple.com/legal/sales-support/'}
                            />
                        </div>
                    </Col>
                </Row>
                <br className='show-md-up' />
            </Container>
        </div>
    );
};
export default InternationalCoverageDocs;
